import React from 'react'

function Icon({icon}) {
  return (
    <img className="max-w-[128px]" src={icon}/>
  )
}

export default Icon